import { FC, useCallback } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { authnClient } from '@frontend/auth';
import { useTranslation } from '@frontend/i18n';
import { ConfirmationModal, useModalControl, Button } from '@frontend/design-system';
import { pendoTags } from '../../../../constants';
import { useSendFormsStore } from '../../../../providers';
import { ContextPreview } from './context-preview/context-preview.component';
import { containerStyle, qrContainerStyle, qrStyle } from './kiosk-message-mode.styles';
import { ThreadHeader } from './thread-header/thread-header.component';

export const KioskDeliveryMode: FC = () => {
  const { t } = useTranslation('digital-forms-sending-experience');
  const { modalProps, openModal } = useModalControl();
  const { solicitedLink } = useSendFormsStore(['solicitedLink']);

  const launchKiosk = useCallback(async () => {
    window.open(solicitedLink, '_blank', 'noopener,noreferrer');
    await authnClient.signOut();
  }, [solicitedLink]);

  return (
    <div css={containerStyle}>
      <ThreadHeader>
        <ContextPreview />
      </ThreadHeader>
      <div css={qrContainerStyle}>
        <QRCodeCanvas value={solicitedLink} size={172} css={qrStyle} id='kiosk-qr' />
        <Button variant='primary' onClick={openModal} trackingId={pendoTags.steps.deliveryMethod.kiosk.launch}>
          {t('Launch Kiosk')}
        </Button>
      </div>
      <ConfirmationModal
        title={t('Launch Kiosk Mode')}
        message={t(
          'Launching Kiosk Mode on this device logs you out of the Weave app for security reasons. This opens the Patient Kiosk View, allowing patients to fill out forms. Do you want to proceed?'
        )}
        confirmLabel={t('Confirm')}
        onConfirm={launchKiosk}
        {...modalProps}
      />
    </div>
  );
};
